import axios from "axios";
import {
  ENDPOINT_THEME_CREATE,
  ENDPOINT_THEME_DEFAULT,
  ENDPOINT_THEME_DELETE,
  ENDPOINT_THEME_UPDATE,
  ENPOINT_THEMES,
} from "../../../constants";
import { ThemeData, ThemeResponse } from "./data";
import { ApiResponse } from "../../types";
import { handleApiError } from "../../../utils/error_handler";

export async function retrieveThemes(): Promise<ThemeResponse> {
  try {
    const res = await axios.get<ApiResponse<ThemeResponse>>(ENPOINT_THEMES);
    if (res.data.Code !== '200') {
      throw handleApiError({ response: { data: res.data } });
    }
    console.log("Retrieved themes:", res.data);
    return res.data.Msg as ThemeResponse;
  } catch (error: any) {
    throw handleApiError(error);
  }
}

export async function updateTheme(theme: ThemeData): Promise<void> {
  try {
    const res = await axios.post<ApiResponse<void>>(ENDPOINT_THEME_UPDATE, theme);
    if (res.data.Code !== '200') {
      throw handleApiError({ response: { data: res.data } });
    }
  } catch (error: any) {
    throw handleApiError(error);
  }
}

export async function deleteTheme(id: string): Promise<void> {
  try {
    const res = await axios.get<ApiResponse<void>>(ENDPOINT_THEME_DELETE + "?id=" + id);
    if (res.data.Code !== '200') {
      throw handleApiError({ response: { data: res.data } });
    }
  } catch (error: any) {
    throw handleApiError(error);
  }
}

// create a theme based from data and returns new theme id
export async function createTheme(theme: ThemeData): Promise<string> {
  try {
    const res = await axios.post<ApiResponse<string>>(ENDPOINT_THEME_CREATE, theme);
    if (res.data.Code !== '200') {
      throw handleApiError({ response: { data: res.data } });
    }
    return res.data.Msg as string || '';
  } catch (error: any) {
    throw handleApiError(error);
  }
}

export async function updateDefaultTheme(id: string): Promise<void> {
  try {
    const res = await axios.post<ApiResponse<void>>(ENDPOINT_THEME_DEFAULT + "?id=" + id);
    if (res.data.Code !== '200') {
      throw handleApiError({ response: { data: res.data } });
    }
  } catch (error: any) {
    throw handleApiError(error);
  }
}
